import React from 'react';
import ReaderWrapper from '../ReaderWrapper';
import { withStyles } from '@material-ui/core/styles';

const styles = {
    flightContainer: {
        overflowX: 'scroll',
    },
    header: {
        fontWeight: '600',
    },
    downloadLink: {
        fontWeight: '500',
    },
};

class InfoReader extends React.Component {
    constructor() {
        super();
        this.state = {
            windowsVersion: ['Loading...'],
            windowsReleaseDate: ['Loading...'],
            windowsDownload: ['Loading...'],

            amazon1Version: ['Loading...'],
            amazon1ReleaseDate: ['Loading...'],
            amazon1Download: ['Loading...'],

            rhel7Version: ['Loading...'],
            rhel7ReleaseDate: ['Loading...'],
            rhel7Download: ['Loading...'],

            ubuntuVersion: ['Loading...'],
            ubuntuReleaseDate: ['Loading...'],
            ubuntuDownload: ['Loading...'],
        };
    }

    componentDidMount() {
        const objThis = this;
        fetch('https://prod-updates-signiant-com.s3.amazonaws.com/flight-gateway/flight-gateway.docs.json')
            .then((response) => response.json())
            .then((findresponse) => {
                this.setState({
                    windowsVersion: findresponse['win64-msi'].version.substring(0, 8),
                    windowsReleaseDate: findresponse['win64-msi'].builtOn.substring(0, 10),
                    windowsDownload: findresponse['win64-msi'].filename,
                    amazon1Version: findresponse['linux-amzn1'].version.substring(0, 8),
                    amazon1ReleaseDate: findresponse['linux-amzn1'].builtOn.substring(0, 10),
                    amazon1Download: findresponse['linux-amzn1'].filename,
                    rhel7Version: findresponse['linux-rhel7'].version.substring(0, 8),
                    rhel7ReleaseDate: findresponse['linux-rhel7'].builtOn.substring(0, 10),
                    rhel7Download: findresponse['linux-rhel7'].filename,
                    ubuntuVersion: findresponse['linux-ubuntu'].version.substring(0, 8),
                    ubuntuReleaseDate: findresponse['linux-ubuntu'].builtOn.substring(0, 10),
                    ubuntuDownload: findresponse['linux-ubuntu'].filename,
                });
            });
    }

    render() {
        const { classes } = this.props;
        return (
            <ReaderWrapper>
                <table>
                    <thead className={classes.header}>
                        <td>Operating System</td>
                        <td>Gateway Version</td>
                        <td>Release Date</td>
                        <td></td>
                    </thead>
                    <tr>
                        <td>Microsoft Windows (64-bit)</td>
                        <td>{this.state.windowsVersion}</td>
                        <td>{this.state.windowsReleaseDate}</td>
                        <td>
                            <a
                                id="download-flight-gateway-windows"
                                className={classes.downloadLink}
                                href={'https://updates.signiant.com/flight-gateway/' + this.state.windowsDownload}
                            >
                                Download
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>Amazon Linux 1</td>
                        <td>{this.state.amazon1Version}</td>
                        <td>{this.state.amazon1ReleaseDate}</td>
                        <td>
                            <a
                                id="download-flight-gateway-amazon-linux-1"
                                className={classes.downloadLink}
                                href={'https://updates.signiant.com/flight-gateway/' + this.state.amazon1Download}
                            >
                                Download
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>Amazon Linux 2 / CentOS / Red Hat</td>
                        <td>{this.state.rhel7Version}</td>
                        <td>{this.state.rhel7ReleaseDate}</td>
                        <td>
                            <a
                                id="download-flight-gateway-amazon-linux-2-centos-redhat"
                                className={classes.downloadLink}
                                href={'https://updates.signiant.com/flight-gateway/' + this.state.rhel7Download}
                            >
                                Download
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>Ubuntu Linux</td>
                        <td>{this.state.ubuntuVersion}</td>
                        <td>{this.state.ubuntuReleaseDate}</td>
                        <td>
                            <a
                                id="download-flight-gateway-unbuntu-linux"
                                className={classes.downloadLink}
                                href={'https://updates.signiant.com/flight-gateway/' + this.state.ubuntuDownload}
                            >
                                Download
                            </a>
                        </td>
                    </tr>
                </table>
            </ReaderWrapper>
        );
    }
}

export default withStyles(styles)(InfoReader);
